import React from "react";
import styled from "@emotion/styled";
import { LinkType } from "@types";
import { Box, IBoxProps } from "@atoms";
import { renderIf } from "@services";
import { LinkPill } from "@molecules";
import { useStoreAppValue } from "@hooks";
import { TDispatch, TLinkTypes } from "../types";

// == Types ================================================================

type TLinkTypeFilter = TLinkTypes | "ALL";

interface IProps extends IBoxProps {
  linkTypeFilter: TLinkTypeFilter | null;
  dispatch: TDispatch;
  nearbySearch?: boolean;
}

// == Constants ============================================================

BrandListLinkTypeFilters.defaultProps = {
  nearbySearch: false,
};

// == Component ============================================================

export default function BrandListLinkTypeFilters({
  nearbySearch,
  linkTypeFilter,
  dispatch,
  ...rest
}: IProps) {
  const { currency } = useStoreAppValue();
  return (
    <EContainer mb={4} {...rest}>
      <ELinkPill
        isActive={linkTypeFilter === null || linkTypeFilter === "ALL"}
        text="All"
        onClick={() => dispatch({ type: "SET_TYPE_FILTER", linkTypeFilter: null })}
      />
      {!nearbySearch && (
        <ELinkPill
          isActive={linkTypeFilter === LinkType.BRAND}
          text="Online"
          onClick={() => dispatch({ type: "SET_TYPE_FILTER", linkTypeFilter: LinkType.BRAND })}
        />
      )}
      <ELinkPill
        isActive={linkTypeFilter === LinkType.GIFTCARDOFFER}
        text="Gift Cards"
        onClick={() =>
          dispatch({ type: "SET_TYPE_FILTER", linkTypeFilter: LinkType.GIFTCARDOFFER })
        }
      />
      {renderIf(currency === "USD")(
        <ELinkPill
          last
          isActive={linkTypeFilter === LinkType.EMPYR}
          text="In-Store"
          onClick={() => dispatch({ type: "SET_TYPE_FILTER", linkTypeFilter: LinkType.EMPYR })}
        />
      )}
    </EContainer>
  );
}

// == Styles ===============================================================

const EContainer = styled(Box)`
  overflow-x: auto;
  white-space: nowrap;

  @media only screen and (min-width: ${(props) => props.theme.breakpoints[2]}) {
    white-space: normal;
    overflow-x: hidden;
    display: flex;
    justify-content: flex-start;
  }
`;

const ELinkPill = styled(LinkPill)`
  margin-right: ${(props) => (props.last ? 0 : `${props.theme.space[2]}px`)};
`;
